(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initShopFaq(root) {
    if (!root || root.dataset.faqReady === 'true') return;
    root.dataset.faqReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.shop-faq__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.shop-faq__panel'));
    var dropdown = root.querySelector('[data-faq-dropdown]');
    var ddToggle = dropdown && dropdown.querySelector('.shop-faq__dropdown-toggle');
    var ddLabel = dropdown && dropdown.querySelector('[data-faq-dropdown-label]');
    var ddList = dropdown && dropdown.querySelector('.shop-faq__dropdown-list');
    var ddOptions = dropdown ? Array.prototype.slice.call(dropdown.querySelectorAll('li[role="option"]')) : [];

    function closeDropdown() {
      if (!dropdown) return;
      ddList.hidden = true;
      ddToggle.setAttribute('aria-expanded', 'false');
    }

    function openDropdown() {
      if (!dropdown) return;
      ddList.hidden = false;
      ddToggle.setAttribute('aria-expanded', 'true');
    }

    function activate(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) {
        var show = p.id === tab.getAttribute('aria-controls');
        if (show) {
          p.hidden = false;
          p.classList.add('is-entering');
          void p.offsetWidth; /* 強制リフロー: エンター状態から遷移させる */
          requestAnimationFrame(function () {
            p.classList.remove('is-entering');
          });
        } else {
          p.hidden = true;
          p.classList.remove('is-entering');
        }
      });
      if (ddLabel) ddLabel.textContent = tab.textContent;
      ddOptions.forEach(function (o) {
        o.setAttribute('aria-selected', o.dataset.key === tab.dataset.key ? 'true' : 'false');
      });
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(tab, false);
        history.replaceState(null, '', '#' + tab.dataset.key);
      });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) {
          e.preventDefault();
          activate(next, true);
        }
      });
    });

    if (dropdown) {
      ddToggle.addEventListener('click', function () {
        if (ddList.hidden) {
          openDropdown();
        } else {
          closeDropdown();
        }
      });

      ddOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          var target = tabs.filter(function (t) { return t.dataset.key === option.dataset.key; })[0];
          if (target) {
            activate(target, false);
            history.replaceState(null, '', '#' + target.dataset.key);
          }
          closeDropdown();
          ddToggle.focus();
        });
      });

      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) closeDropdown();
      });

      dropdown.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeDropdown();
          ddToggle.focus();
        }
      });
    }

    /* 初期選択中のタブ名をドロップダウンのラベルに反映 */
    if (ddLabel) {
      var initialTab = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
      if (initialTab) ddLabel.textContent = initialTab.textContent;
    }

    /* URLハッシュ（例: /pages/faq#shipping）で該当タブを開く */
    var hash = location.hash.replace('#', '');
    if (hash) {
      var target = tabs.filter(function (t) { return t.dataset.key === hash; })[0];
      if (target) activate(target, false);
    }

    root.querySelectorAll('.shop-faq__q button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var answer = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        answer.classList.toggle('is-open', !open);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-shop-faq]').forEach(initShopFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* テーマエディタでセクションが再描画されたときの再初期化 */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector && e.target.querySelector('[data-shop-faq]');
    if (el) initShopFaq(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
